module.exports = __webpack_public_path__ + "img/img4.0ad9252f.png";